<div class="mds">
  @if (!isLoading && !error) {
    <markdown [data]="markdownContent" [disableSanitizer]="true"></markdown>
  }
</div>
